import { useState } from "react";
import { Button } from "../../design/button";
import { Heading } from "../../design/heading";
import { Text } from "../../design/text";
import { Product } from "../../models/Product";
import { CheckoutService } from "../../services/CheckoutService";
import { useMatter } from "../../contexts/MatterContext";
import { products } from "../../constants/products";

export const ProductsListPage: React.FC = () => {
  const [loadingProductId, setLoadingProductId] = useState<string | null>(null);

  return (
    <div className="flex flex-col space-y-4">
      <Heading>Products</Heading>
      <div className="grid grid-cols-1 gap-6 p-6 md:grid-cols-2">
        {Object.entries(products).map(([key, product]) => (
          <div
            key={product.id}
            className="flex flex-col justify-between p-6 bg-gray-100 border shadow-sm rounded-xl dark:bg-zinc-900"
          >
            <div className="space-y-2">
              <Heading level={3}>{product.title}</Heading>
              <Text>{product.description}</Text>
            </div>

            <div className="flex items-center justify-between mt-4">
              <div className="text-xl font-semibold">${product.price}</div>
              <Button
                href={`/product/${key}`}
                disabled={loadingProductId === product.id}
              >
                {loadingProductId === product.id ? "Loading..." : "Unlock"}
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
